import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { SearchNavbarBaseSubformComponent } from '@shared/components/search-layout/search-navbar/search-navbar-base-subform/search-navbar-base-subform.component';

@Component({
  selector: 'app-selector-subform',
  templateUrl: './selector-subform.component.html',
  styleUrls: ['./selector-subform.component.scss'],
})
export class SelectorSubformComponent
  extends SearchNavbarBaseSubformComponent
  implements OnInit
{
  @Input() override data!: {
    enum?: Array<any>;
    labelAttribute?: string;
    valueAttribute?: string;
    isMultiple?: boolean;
    asyncOptionsSelector?: any;
    showSelectedLabels?: boolean;
    filter?: any;
    optionTitlePrefix?: string;
  };

  override group = this.fb.group({
    option: new UntypedFormControl(null, []),
  });

  previousValue: any = null;

  enum!: any;

  override ngOnInit(): void {
    super.ngOnInit();
    if (
      this.data.filter?.[this.property] &&
      this.data.filter?.[this.property].length > 0
    ) {
      this.group.controls['option'].setValue(this.data.filter[this.property]);
    }

    if (this.data.asyncOptionsSelector) {
      this.store
        .select(this.data.asyncOptionsSelector)
        .subscribe((options) => (this.enum = options));
    } else {
      this.enum = this.data.enum;
    }
  }

  override updateValue(filter?: any): void {
    this.clear();
    if (filter && filter[this.property]) {
      this.group.controls['option'].setValue(filter[this.property]);
      this.valueChanged(filter[this.property]);
    }
    if (!filter) {
      this.clear();
    }
  }

  valueChanged(event: string | null | any): void {
    if (event !== this.previousValue) {
      this.previousValue = event;
      this.store.dispatch(
        this.filterUpdater.trigger({
          filter: {
            [this.property]: event,
          },
        })
      );
    }
  }

  override clear(): void {
    this.group.reset();
    this.valueChanged(null);
  }
}
